// Every entrypoint that loads legacy code imports this module first, so legacy modules can
// read the `jQuery` global while they evaluate.
//
// `jquery` resolves to the vendored `jquery3.js`, which the build bundles and the dev server
// pre-bundles as a CommonJS module: it exports jQuery and sets no global. This module sets
// `window.jQuery` and `window.$` when the page has no `window.jQuery`, and leaves a jQuery
// already on the page as it is. Either way it installs the locale prefilter on that jQuery.
import jQuery from "jquery";

import { installLocaleAjaxPrefilter } from "./locale-ajax-prefilter.js";

if (window.jQuery === undefined) {
  window.jQuery = jQuery;
  window.$ = jQuery;
}

installLocaleAjaxPrefilter(window.jQuery);
